import React from "react";

const NoteSkeleton = () => {
  return (
    <div>
      <div className="skeleton-note">
      <div className="skeleton-title"></div>
      <div className="skeleton-content"></div>
    </div>
    </div>
  );
};

export default NoteSkeleton;
